/*
  俄语（ru-RU）
*/
export default {
  headerBar: {
    allProducts: 'все продукты',
    newIn: 'новый вход',
    bestSellers: 'бестселлер',
    specialOffer: 'Специальные льготы',
    explore: 'разведка',
    fashionTrends: 'мода',
    whyUs: 'Почему мы',
    helpCenter: 'Центр помощи',
    company: 'компания',
    dropshipping: 'прямая отправка',
    aboutUs: 'о нас',
    blog: 'блог',
    login: 'Имя пользователя',
    register: 'бесплатная регистрация',
    searchingFor: 'поиск',
    wishList: 'список желаний',
    listing: 'реестр',
    allOrder: 'все заказы',
    accountSetting: 'Настройки счетов',
    logOut: 'Списание',
    home: 'жилище',
    startSelling: 'начать продажу',
    wholesale: 'оптовая торговля'
  },
  indexPage: {
    hello: 'Здравствыйте',
    allCategory: 'все категории',
    apparelWholesale: 'оптовая торговля одеждой',
    smartDropshiping: 'интеллектуальное перетаскивание',
    smallMOQCustomization: 'мини - заказ MOQ',
    fastWorldwideShipping: 'быстрая глобальная отправка',
    estimateShippingCost: 'оценка транспортных издержек',
    flashSale: 'молниеносная продажа',
    customization: 'другой',
    customizationText1: 'более 500 поставщиков и более 100 дизайнеров,',
    customizationText2: 'эксклюзивный продукт может быть только для вас.',
    ins: 'выбор воздействующей стороны',
    insText1: 'последний фасон модный, чтобы получить костюм inspo.',
    insText2: 'предложить такой же дизайн для вашей продажи.',
    youMayLike: 'Может тебе понравится',
    viewMore: 'смотреть больше'
  }
}
